import React, { type ReactNode, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import type { IIntegrationFormImplProps } from "src/integrations/forms/IIntegrationFormImplProps";
import {
  INTEGRATION_SHOPIFY_ACCESS_TOKEN,
  INTEGRATION_SHOPIFY_API_KEY,
  INTEGRATION_SHOPIFY_API_SECRET,
  INTEGRATION_SHOPIFY_SHOP_DOMAIN,
} from "src/integrations/forms/shopify/IIntegrationFormDataShopify";
import {
  Showable,
  ShowableInputButtonStyled,
  ShowableInputRow,
} from "src/shared/components/Showable";
import { TextInput } from "src/shared/forms/inputs/TextInput";

export interface IntegrationFormShopifyProps extends IIntegrationFormImplProps {
  children?: ReactNode;
  apiKeyRequired?: boolean;
  showsAccessToken?: boolean;
}

export function IntegrationFormShopify({
  isEdit,
  apiKeyRequired = false,
  showsAccessToken = true,
  children,
}: IntegrationFormShopifyProps) {
  const shopDomainRegex = useMemo(
    () => new RegExp("[^.\\s]+\\.myshopify\\.com$"),
    [],
  );
  const apiKeyRegex = useMemo(() => new RegExp("^[a-zA-Z0-9_-]*$"), []);
  const accessTokenRegex = useMemo(() => new RegExp("^[a-zA-Z0-9_-]*$"), []);
  const apiSecretRegex = useMemo(() => new RegExp("^[a-zA-Z0-9_-]*$"), []);
  // const phoneLabelRegex = useMemo(() => new RegExp("^[a-zA-Z0-9_-]*$"), []);

  return (
    <>
      <TextInput
        inputID={INTEGRATION_SHOPIFY_SHOP_DOMAIN}
        label={<FormattedMessage id="integrations.shopify.shop_domain" />}
        maxLength={128}
        regex={shopDomainRegex}
        disabled={isEdit}
      />

      <TextInput
        inputID={INTEGRATION_SHOPIFY_API_KEY}
        label={<FormattedMessage id="integrations.shopify.api_key" />}
        isRequired={apiKeyRequired}
        minLength={1}
        maxLength={64}
        regex={apiKeyRegex}
        disabled={isEdit}
        autoComplete="off"
      />

      {showsAccessToken && (
        <Showable ButtonClass={ShowableInputButtonStyled}>
          {(shown, button) => (
            <ShowableInputRow>
              <TextInput
                inputID={INTEGRATION_SHOPIFY_ACCESS_TOKEN}
                label={
                  <FormattedMessage id="integrations.shopify.accessToken" />
                }
                type={shown ? "text" : "password"}
                isRequired={false}
                minLength={1}
                maxLength={128}
                regex={accessTokenRegex}
                disabled={isEdit}
                autoComplete="off"
              />
              {button}
            </ShowableInputRow>
          )}
        </Showable>
      )}

      <TextInput
        inputID={INTEGRATION_SHOPIFY_API_SECRET}
        label={<FormattedMessage id="integrations.shopify.apiSecret" />}
        isRequired
        minLength={1}
        maxLength={64}
        regex={apiSecretRegex}
        disabled={isEdit}
        autoComplete="off"
      />

      {children}

      {/*<TextInput*/}
      {/*  inputID={INTEGRATION_SHOPIFY_PHONE_LABEL}*/}
      {/*  label={<FormattedMessage id="integrations.shopify.phone_label" />}*/}
      {/*  minLength={1}*/}
      {/*  maxLength={32}*/}
      {/*  regex={phoneLabelRegex}*/}
      {/*  formText={*/}
      {/*    <FormText color="muted">*/}
      {/*      <FormattedMessage id="offers.sms_body_already_registered.tooltip" />*/}
      {/*    </FormText>*/}
      {/*  }*/}
      {/*  tooltip={*/}
      {/*    <Tooltip*/}
      {/*      tag="span"*/}
      {/*      isOpen*/}
      {/*      tooltipProps={{ placement: "right" }}*/}
      {/*      tooltipRender={*/}
      {/*        <FormattedMessage id="offers.sms_body_already_registered.tooltip.2" />*/}
      {/*      }*/}
      {/*    >*/}
      {/*      <InfoCircle />*/}
      {/*    </Tooltip>*/}
      {/*  }*/}
      {/*/>*/}
    </>
  );
}
